
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { FileText, Download } from 'lucide-react';
import { downloadFlightTemplate } from '@/utils/csvTemplate';

interface FileUploadSectionProps {
  file: File | null;
  onFileChange: (file: File | null) => void;
}

export function FileUploadSection({ file, onFileChange }: FileUploadSectionProps) {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile && selectedFile.type === 'text/csv') {
      onFileChange(selectedFile);
    } else {
      onFileChange(null);
    }
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={downloadFlightTemplate}
          className="flex items-center gap-2"
        >
          <Download className="h-4 w-4" />
          Download CSV Template
        </Button>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="csv-file">CSV File</Label>
        <Input
          id="csv-file"
          type="file"
          accept=".csv"
          onChange={handleFileChange}
        />
      </div>
      
      {file && (
        <div className="flex items-center gap-2 p-3 border rounded-md bg-muted/20">
          <FileText className="h-4 w-4" />
          <span className="text-sm">{file.name}</span>
          <span className="text-xs text-muted-foreground">
            ({(file.size / 1024).toFixed(1)} KB)
          </span>
        </div>
      )}
    </>
  );
}
